// extracted by mini-css-extract-plugin
export default {"search":"SearchCardapioMobile_search__tXfAO","show":"SearchCardapioMobile_show__ZPEHz","search_button":"SearchCardapioMobile_search_button__ep8cy"};